import React from "react"
import { cn } from "../utils"
import { Tabs } from "../tabs-new"
import type { TabsListProps } from "../tabs-new"
import { PageSecondaryHeaderCenterContent } from "./page-secondary-header-center-content"
import { pageSecondaryHeaderTabContainerStyles } from "./page-secondary-header-tab-container-styles"

// =============================================================================
// Props
// =============================================================================

export type PageSecondaryHeaderTabsProps = TabsListProps

// =============================================================================
// Component
// =============================================================================

/**
 * Secondary page header tabs (panel-switching).
 *
 * Composes `Tabs.List` (role="tablist") for switching between panels on the
 * same page. Compose with `PageSecondaryHeader.Tab` for each tab, and place
 * the corresponding `PageSecondaryHeader.TabPanel`s in the page content.
 *
 * **Requires a `PageSecondaryHeader.TabsRoot` ancestor** wrapping both the
 * page header and the panels, since they live in different parts of the tree
 * but share the selected tab.
 *
 * For navigation links that *look* like tabs (cross-page navigation, not
 * panel-switching), use `PageSecondaryHeader.TabLinks` instead, which renders a
 * `<nav>` landmark with `<a>` elements and `aria-current="page"`.
 */
export function PageSecondaryHeaderTabs({
  className,
  ...props
}: PageSecondaryHeaderTabsProps) {
  return (
    <PageSecondaryHeaderCenterContent>
      <Tabs.List
        className={cn(pageSecondaryHeaderTabContainerStyles, className)}
        {...props}
      />
    </PageSecondaryHeaderCenterContent>
  )
}
